import { IconPropsType } from '..';

export const ArrowLeftLongIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8332 3.50278H2.43317L4.5545 1.36945L3.71984 0.533447L0.166504 4.09478L3.7225 7.65078L4.55717 6.81478L2.43317 4.68678H10.8332V3.50278Z"
        fill="#6A6F85"
      />
    </svg>
  );
};
